import {
  concederAcessoSchema,
  initialValuesFragment,
  mapSubmitValues
} from '../utils/functions'
import { useSnackbar } from '@tecsinapse/cortex-react'
import { CONCEDER_ACESSO } from '../data/conceder-acesso'
import { SubmitHandler, useForm } from 'react-hook-form'
import { NovaPastaValues } from './use-nova-pasta-dialog'
import {
  ConcederAcessoMutationMutation,
  ConcederAcessoMutationMutationVariables,
  ItemBiblioteca
} from '@/core/types/graphql'
import { t } from '@lingui/core/macro'
import { zodResolver } from '@hookform/resolvers/zod'
import { request } from '../../../core/utils/request'
import { useMutation } from '@tanstack/react-query'
import { getGraphQLErrorMessage } from '@/core/utils/graphql-error'

export type ConcederAcessoValues = Omit<NovaPastaValues, 'idPai' | 'nome'>

export const useConcederAcessoDialog = ({
  pastaAtual,
  close
}: {
  pastaAtual: ItemBiblioteca
  close: () => void
}) => {
  const { snackbar } = useSnackbar()

  const concederAcessoMutation = useMutation({
    mutationKey: ['concederAcesso'],
    mutationFn: async ({
      variables
    }: {
      variables: ConcederAcessoMutationMutationVariables
    }) =>
      await request<
        ConcederAcessoMutationMutation,
        ConcederAcessoMutationMutationVariables
      >(CONCEDER_ACESSO, { variables })
  })

  const initialValues = initialValuesFragment(pastaAtual)

  const form = useForm<ConcederAcessoValues>({
    values: initialValues,
    resolver: zodResolver(concederAcessoSchema),
    mode: 'onSubmit'
  })

  const onSubmit: SubmitHandler<ConcederAcessoValues> = async values => {
    const { tiposAcesso } = mapSubmitValues(values)

    const novasPermissoes = {
      tiposAcesso,
      idPasta: pastaAtual.id
    }

    try {
      await concederAcessoMutation.mutateAsync({
        variables: {
          novasPermissoes
        }
      })

      snackbar.show('success', t`Acesso concedido com sucesso!`)

      form.reset()
      close()
    } catch (error) {
      snackbar.show('error', t`Erro ao conceder acesso`)
      console.error(getGraphQLErrorMessage(error))
    }
  }

  const closeForm = () => {
    form.reset()
    close()
  }

  return {
    form,
    onSubmit,
    closeForm
  }
}
